module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "presupuesto-print"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/contenido/banner-print.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "davi-curs title-print"
  }, [_vm._v("Presupuesto Mensual")]), _vm._v(" "), _c('div', {
    staticClass: "title-print-two span-red"
  }, [_vm._v("Ingresos")]), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, _vm._l((_vm.nombresUno), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item.parteUno) + " ")]), _c('br'), _vm._v(" " + _vm._s(item.parteDos) + "\n      ")])
  })), _vm._v(" "), _vm._l((_vm.ingresoSalario), function(item, index) {
    return (item.valorUno || item.valorDos) ? _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(item.nombre) + "\n      ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "valor"
    }, [(item.valorUno) ? [_vm._v(" $" + _vm._s(item.valorUno) + " ")] : _vm._e(), _vm._v(" "), (!item.valorUno) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('div', {
      staticClass: "valor"
    }, [(item.valorDos) ? [_vm._v(" $" + _vm._s(item.valorDos) + " ")] : _vm._e(), _vm._v(" "), (!item.valorDos) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.ingresoSalarioDiferencia[index]))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', _vm._l((_vm.ingresoSalarioTotal), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))], 2), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.nombresDos), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.otrosIngresoSalario), function(item, index) {
    return (item.valorUno || item.valorDos) ? _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(item.nombre) + "\n      ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "valor"
    }, [(item.valorUno) ? [_vm._v(" $" + _vm._s(item.valorUno) + " ")] : _vm._e(), _vm._v(" "), (!item.valorUno) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('div', {
      staticClass: "valor"
    }, [(item.valorDos) ? [_vm._v(" $" + _vm._s(item.valorDos) + " ")] : _vm._e(), _vm._v(" "), (!item.valorDos) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.OtrosIngresoSalarioDiferencia[index]))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', _vm._l((_vm.OtrosIngresoSalarioTotal), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))], 2), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', _vm._l((_vm.ingresosMasOtrosIngresos), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title-print-two span-red"
  }, [_vm._v("Gastos fijos")]), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.nombresDos), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.gastosFijos), function(item, index) {
    return (item.valorUno || item.valorDos) ? _c('tr', [_c('td', [(!item.otro) ? [_vm._v("\n          " + _vm._s(item.nombre) + "\n        ")] : _vm._e(), _vm._v(" "), (item.otro) ? [_vm._v("\n          " + _vm._s(item.otro) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "valor"
    }, [(item.valorUno) ? [_vm._v(" $" + _vm._s(item.valorUno) + " ")] : _vm._e(), _vm._v(" "), (!item.valorUno) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('div', {
      staticClass: "valor"
    }, [(item.valorDos) ? [_vm._v(" $" + _vm._s(item.valorDos) + " ")] : _vm._e(), _vm._v(" "), (!item.valorDos) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.gastosFijosDiferencia[index]))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', _vm._l((_vm.gastosFijosTotal), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title-print-two span-red"
  }, [_vm._v(" Gastos variables")]), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.nombresDos), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.gastosVariables), function(item, index) {
    return (item.valorUno || item.valorDos) ? _c('tr', [_c('td', [(!item.otro) ? [_vm._v("\n          " + _vm._s(item.nombre) + "\n        ")] : _vm._e(), _vm._v(" "), (item.otro) ? [_vm._v("\n          " + _vm._s(item.otro) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "valor"
    }, [(item.valorUno) ? [_vm._v(" $" + _vm._s(item.valorUno) + " ")] : _vm._e(), _vm._v(" "), (!item.valorUno) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('div', {
      staticClass: "valor"
    }, [(item.valorDos) ? [_vm._v(" $" + _vm._s(item.valorDos) + " ")] : _vm._e(), _vm._v(" "), (!item.valorDos) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.gastosVariablesDiferencia[index]))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', _vm._l((_vm.gastosVariablesTotal), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "title-print-two span-red"
  }, [_vm._v(" Gastos opcionales")]), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.nombresDos), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  })], 2), _vm._v(" "), _vm._l((_vm.gastosOpcionales), function(item, index) {
    return (item.valorUno || item.valorDos) ? _c('tr', [_c('td', [(!item.otro) ? [_vm._v("\n          " + _vm._s(item.nombre) + "\n        ")] : _vm._e(), _vm._v(" "), (item.otro) ? [_vm._v("\n          " + _vm._s(item.otro) + "\n        ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "valor"
    }, [(item.valorUno) ? [_vm._v(" $" + _vm._s(item.valorUno) + " ")] : _vm._e(), _vm._v(" "), (!item.valorUno) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "input-td"
    }, [_c('div', {
      staticClass: "valor"
    }, [(item.valorDos) ? [_vm._v(" $" + _vm._s(item.valorDos) + " ")] : _vm._e(), _vm._v(" "), (!item.valorDos) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center"
    }, [_c('span', {
      staticClass: "font-red "
    }, [_vm._v(_vm._s(_vm.gastosOpcionalesDiferencia[index]))])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', _vm._l((_vm.gastosOpcionalesTotal), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "html2pdf__page-break"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "davi-curs title-print span-red"
  }, [_vm._v("Presupuesto")]), _vm._v(" "), _vm._m(4), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.nombresDos), function(item) {
    return _c('th', [_c('span', {
      staticClass: "span-red davi-curs"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  })], 2), _vm._v(" "), _c('tr', _vm._l((_vm.ingresosMasOtrosIngresos), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.totalGastos), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  })), _vm._v(" "), _c('tr', _vm._l((_vm.flujoDeCaja), function(item, index) {
    return _c('td', [_c('div', {
      staticClass: "valor-total"
    }, [(item) ? [_vm._v(" " + _vm._s(index > 0 ? '$' : '') + _vm._s(item) + " ")] : _vm._e(), _vm._v(" "), (!item) ? [_vm._v(" $" + _vm._s(0) + " ")] : _vm._e()], 2)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v(" Otros ingresos mensuales ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v(" Gastos fijos mensuales ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v(" Gastos variables mensuales ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v(" Gastos opcionales mensuales ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Teniendo en cuenta sus ingresos y sus gastos, este sería  su flujo de caja mensual")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('span', {
    staticClass: "span-red davi-curs"
  }, [_vm._v(" Presupuesto ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43fcb815","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FormCalculadoraPrint.vue
// module id = 968
// module chunks = 1